<div class="modal-header">
    <h5 class="modal-title">
        <i class="ti ti-lock me-2"></i>
        Alterar Senha ({{ userFirstName() }} {{ userLastName() }})
    </h5>
    <button type="button" class="btn-close" (click)="cancel()" [disabled]="loading" tabindex="-1"></button>
</div>

<div class="modal-body">

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Nova Senha -->
        <div class="password-field-wrapper">
            <app-input
                #passwordInput
                formControlName="password"
                [type]="showPassword() ? 'text' : 'password'"
                label="USERS.CHANGE_PASSWORD.NEW_PASSWORD"
                placeholder="USERS.CHANGE_PASSWORD.NEW_PASSWORD_PLACEHOLDER"
                groupIcon="{{showPassword() ? 'ti-eye-off' : 'ti-eye'}}"
                groupIconPosition="left"
                autocomplete="new-password"
                containerStyles="mb-3"
                (onClick)="togglePasswordVisibility()"
                [readonly]="loading"
            />
        </div>

        <!-- Confirmar Senha -->
        <div class="password-field-wrapper">
            <app-input
                    formControlName="confirmPassword"
                    [type]="showConfirmPassword() ? 'text' : 'password'"
                    label="USERS.CHANGE_PASSWORD.CONFIRM_PASSWORD"
                    placeholder="USERS.CHANGE_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER"
                    groupIcon="{{showConfirmPassword() ? 'ti-eye-off' : 'ti-eye'}}"
                    groupIconPosition="left"
                    autocomplete="new-password"
                    containerStyles="mb-0"
                    (onClick)="toggleConfirmPasswordVisibility()"
                    [readonly]="loading"
            />
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        <i class="ti ti-x me-1"></i>
        Cancelar
    </button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">
        <i class="ti ti-check me-1"></i>
        Alterar Senha
    </button>
</div>

